export default {
  addOns: 'Add-ons',
  availability: 'Availability',
  availabilityDaySelector: 'Availability date selector',
  unavailable: 'Unavailable',
  person: 'person',
  people: 'people',
  reserveNow: 'Reserve now',
  selectTime: 'Select time',
  select: 'Select',
  reserve: 'Reserve',
  time: 'Time',
  startTime: 'Start time',
  duration: 'Duration',
  lengthOfStay: 'Length of stay',
  startDate: 'Start date',
  endDate: 'End date',
  selectDates: 'Select dates',
  more: 'More',
  selectStartTime: 'Select a start time',
  endTime: 'End time',
  morning: 'Morning',
  save: 'Save',
  afternoon: 'Afternoon',
  selectEndTime: 'Select an end time',
  selectDuration: 'Select a duration',
  forLength: 'for {{length}}',
  bookedByDay: 'Booked by the day',
  bookedByNight: 'Booked by the night',
  moreDates: '{{count}} more',
  addDate: 'Add date',
  start: 'Start',
  end: 'End',
  pickupFrom: 'Pickup from',
  returnBy: 'Return by',
  tier: 'Tier',
  questions: 'Questions',
  addToCart: 'Add to cart',
  checkout: 'Checkout',
  total: 'Total',
  whatsIncluded: "What's included",
  showMore: 'Show more',
  showLess: 'Show less',
  session: 'Session',
  viewDetails: 'View details',
  findAvailability: 'Find Availability',
  loading: 'Loading',
  capacity: 'Capacity',
  noAvailableSessionsOnThisDate: 'No available sessions on this date',
  noGroupAvailableOnThisDateAndTime:
    'No {{groupTitle}} available at this date and time',
  noCollectionFound: 'No collection found!',
  noResourceGroupFound: 'No resource group found!',
  noData: 'No data!',
  continue: 'Continue',
  night: 'night',
  nights: 'nights',
  noAvailableSessionsForSelectedDates:
    'Some dates in your selection do not have available sessions. Please select different dates.',
  from: 'from',
  dateRangeSelector: 'Date range selector',
  priceTierRadioGroup: 'Price tier radio group',
};
